import React, { FC, useContext } from "react";
import { CloseIconThin, HelpDrawer } from "@cmsgov/ds-medicare-gov";
import { FormattedHTMLMessage } from "react-intl-phraseapp";
import { useTranslate } from "../helpers";
import { AppContext } from "../app/store";
import { linkToSpecialEnrollmentPeriodInfo } from "../helpers/CONSTANTS";

export const SEPHelpDrawer: FC<{
  onCloseClick: () => void;
}> = ({ onCloseClick }) => {
  const t = useTranslate();
  const {
    state: { language },
  } = useContext(AppContext);
  return (
    <div className="mct-c-help-drawer">
      <HelpDrawer
        heading={t("dob.sep.help_me")}
        onCloseClick={onCloseClick}
        closeButtonText={<CloseIconThin />}
      >
        <FormattedHTMLMessage id="dob.sep.help_rules" />
        <p>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={linkToSpecialEnrollmentPeriodInfo(language)}
          >
            {t("dob.sep.learn_more")}
          </a>
        </p>
      </HelpDrawer>
    </div>
  );
};
